import { SearchScreen } from '@/features/search/search-screen';
export default SearchScreen;
